export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export function formatDate(date: Date): string {
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

export function formatDateLong(date: Date): string {
  return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
}

export function formatDateRange(start: Date, end: Date): string {
  if (start.getMonth() === end.getMonth()) {
    return formatDateLong(start)
  }
  return `${formatDate(start)} — ${formatDate(end)}`
}

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export function dateFilterToLabel(dateFilter: string): string {
  if (!dateFilter) return 'All'
  if (dateFilter === 'YTD') return 'Year to Date'
  if (dateFilter === 'Last Year') return `${new Date().getFullYear() - 1}`
  const match = /^(\d{4})-(\d{2})$/.exec(dateFilter)
  if (match) {
    const year = match[1]
    const monthIndex = parseInt(match[2], 10) - 1
    if (monthIndex >= 0 && monthIndex < 12) {
      return `${monthNames[monthIndex]} ${year}`
    }
  }
  return dateFilter
}
